import Navbar from './components/Navbar.js';
import s from './App.module.css';
import { Outlet } from 'react-router-dom';  
import { useState } from "react";

function App() {
	const [value, setValue] = useState("");
		
	function logger (cValue) {
    setValue(cValue);
  }
	
	
  return (
    <div className={s.App}>
			
			<div className={s.navbar_holder}>
				<Navbar/>
				<div className={s.popupMsgHolder}>
					<div className={s.popupMsg}>{value}</div>
					<div className={s.popupMsg}>{value}</div>
				</div>
			</div>
			<div className={s.outlet_holder}>
				<Outlet context={[logger]} />
			</div>
    </div>
  );
}

export default App;
